import React, { useState, useEffect, useRef } from "react";
import Loader from "../../components/Common/Loader";
import appInsights from "../../AppInsights";

const LatestUpdate = () => {
  const [loading, setLoading] = useState(true);
  const iframeRef = useRef(null);

  // Page View tracking
  useEffect(() => {
    appInsights.trackPageView({
      name: "LatestUpdatePage",
      properties: {
        page: "Latest Update",
      },
    });
  }, []);

  useEffect(() => {
    const iframe = iframeRef.current;

    const handleLoad = () => {
      setLoading(false);

      // Track iframe load success
      appInsights.trackEvent({
        name: "LatestUpdate_Iframe_Loaded",
        properties: {
          src: "https://apex-website-dev-hdhcdgfvfvbse4aa.westus2-01.azurewebsites.net",
          status: "success",
        },
      });
    };

    const handleError = () => {
      setLoading(false);

      // Track iframe load failure
      appInsights.trackException({
        exception: new Error("LatestUpdate_Iframe_Load_Failed"),
        severityLevel: 2,
        properties: {
          src: "https://apex-website-dev-hdhcdgfvfvbse4aa.westus2-01.azurewebsites.net",
          status: "error",
        },
      });
    };

    if (iframe) {
      iframe.addEventListener("load", handleLoad);
      iframe.addEventListener("error", handleError);
    }

    return () => {
      // Track page unmount
      appInsights.trackEvent({
        name: "LatestUpdate_Page_Unmounted",
        properties: {
          page: "Latest Update",
        },
      });

      if (iframe) {
        iframe.removeEventListener("load", handleLoad);
        iframe.removeEventListener("error", handleError);
      }
    };
  }, []);

  return (
    <div style={{ height: "98%", width: "100%", position: "relative" }}>
      {loading && <Loader />}
      <iframe
        ref={iframeRef}
        src="https://apex-website-dev-hdhcdgfvfvbse4aa.westus2-01.azurewebsites.net"
        style={{ border: "none", width: "100%", height: "100%" }}
        title="Latest Update"
      ></iframe>
    </div>
  );
};

export default LatestUpdate;
